/** module that contains helper functions for working with with equipments
 * @module equipmentService */

/**
 * Set avs as 'selected' if they are in selected equipments.
 * - it mutates the original data structure
 * - looking at this today, it looks really inefficient from time/space complexity perspective, but there are no issues with it, probably since the amount of data is small
 * @returns undefined
 */
const autoSelectEquipments = (selectedEquipments, avs, callback) => {
  for (let i = 0; i < avs.options.length; i++) {
    for (let j = 0; j < avs.options[i].selections.length; j++) {
      for (let k = 0; k < avs.options[i].selections[j].avs.length; k++) {
        for (let l = 0; l < selectedEquipments.length; l++) {
          // checks if equipment is in selected equipments arr
          if (avs.options[i].selections[j].avs[k].av.av === selectedEquipments[l]) {
            if (avs.options[i].selections[j].selectedAvs) {
              // if selectedAvs prop already exists
              if (avs.options[i].selections[j].singleSelection || avs.options[i].selections[j].avs.length === 1) {
                // if type of select is single selection or there is only 1 av, selectedAvs should be a string
                avs.options[i].selections[j].selectedAvs = avs.options[i].selections[j].avs[k].av.id;
              }
              if (avs.options[i].selections[j].selectedAvs.constructor === Array &&
                !avs.options[i].selections[j].selectedAvs.find((id) => id === avs.options[i].selections[j].avs[k].av.id)) {
                // if you can select multiple equipments in a select, push the selected equipment to the array
                avs.options[i].selections[j].selectedAvs.push(avs.options[i].selections[j].avs[k].av.id);
              }
            } else {
              // if selectedAvs prop doesn't exist
              if (avs.options[i].selections[j].singleSelection || avs.options[i].selections[j].avs.length === 1) {
                avs.options[i].selections[j].selectedAvs = avs.options[i].selections[j].avs[k].av.id;
              } else {
                // if you can select multiple equipments in a select, selectedAvs should be an array
                avs.options[i].selections[j].selectedAvs = [avs.options[i].selections[j].avs[k].av.id];
                // We must select all equipments in a selection at once,
                // otherwise will get deleted from temporaryEquipmentAvs array
                for (let l = 0; l < selectedEquipments.length; l++) {
                  for (let m = 0; m < avs.options[i].selections[j].avs.length; m++) {
                    if (selectedEquipments[l] === avs.options[i].selections[j].avs[m].av.av &&
                      !avs.options[i].selections[j].selectedAvs.find((id) => id === avs.options[i].selections[j].avs[m].av.id)) {
                      avs.options[i].selections[j].selectedAvs.push(avs.options[i].selections[j].avs[m].av.id);
                    }
                  }
                }
              }
              // if selection was made, invoke updateAvs to potentially get next equipment options
              callback(avs.options[i], true);
            }
          }
        }
      }
    }
  }
};

/**
 * Concatenates 'OTHER' equipments
 * - avGroup(equipment group) 'OTHER' is displayed as multiple selection component. But since it is received from
 * backend in multiple arrays, we need to concatenate the ones that are optional into one, otherwise multiple multi-select
 * components will be displayed, which doesnt make sense for the user * @returns undefined
 * @returns undefined
 */
const groupOtherEquipments = (avs) => {
  if (avs && Array.isArray(avs.options)) {
    for (const option of avs.options) {
      if (option.avGroup === 'OTHER') {
        let avArr = [];
        for (const selection of option.selections) {
          if (!selection.singleSelection && selection.optional) {
            avArr = avArr.concat(selection.avs);
          }
        }

        option.selections = option.selections.filter(selection => !selection.singleSelection && !selection.optional);

        let selection = {
          optional: true,
          singleSelection: false,
          avs: avArr,
          extra: true
        };
        option.selections.push(selection);
      }
    }
  }
  return avs;
};

export default {
  autoSelectEquipments,
  groupOtherEquipments
}
